import "./css/Suspense.css"

export default function SuspenseBlock() {
    return(
        <div className="suspense">
            <span>Loading...</span>
            <div className="blind"></div>
        </div>
    )
}